import * as angular from "angular";
import {DistrictService} from "../services/district/district.service";
import {MatchingService} from "../services/matching/matching.service";
import {TestImportService} from "../services/test-import/test-import.service";
import {CleverMatchInitService} from "../clever-match-landing/clever-match-init/clever-match-init.service";
import {ImportStatusService} from "../services/import-status/import-status.service";
import {StaffTestImportService} from "../services/staff-test-import/staff-test-import.service";
import {StaffImportRecordsService} from "../services/staff-import-records/staff-import-records.service";
import { FeatureToggleService } from "../services/feature-toggle/feature-toggle.service";
import { ConfigurationService } from "../services/configuration/configuration.service";

export function initRoutes(
    app: angular.IModule) {
    /* @ngInject */
    app.config(function($routeProvider: angular.route.IRouteProvider) {

        /* @ngInject */
        const navianceSchools = ($route: angular.route.IRouteService, districtService: DistrictService) => 
            districtService.getNavianceSchools($route.current.params.districtId);

        /* @ngInject */
        const cleverSchools = ($route: angular.route.IRouteService, districtService: DistrictService) =>
            districtService.getCleverSchools($route.current.params.districtId);

        /* @ngInject */
        const matches = ($route: angular.route.IRouteService, matchingService: MatchingService) => 
            matchingService.getMatchingSchools($route.current.params.districtId);

        /* @ngInject */
        const initData = ($route: angular.route.IRouteService, cleverMatchInitService: CleverMatchInitService) => 
            cleverMatchInitService($route.current.params.districtId);

        /* @ngInject */
        const pilotStatus = ($route: angular.route.IRouteService, importStatusService: ImportStatusService) => 
            importStatusService.getPilotStatus($route.current.params.districtId);
        
        /* @ngInject */
        const staffImportStatus = ($route: angular.route.IRouteService, staffImportRecordsService: StaffImportRecordsService) => 
            staffImportRecordsService.getStaffImportStatus($route.current.params.districtId);

        /* @ngInject */
        const testImportProgress = ($route: angular.route.IRouteService, testImportService: TestImportService) => 
            testImportService.getTestImportProgress($route.current.params.districtId);

        /* @ngInject */
        const staffTestImportStatus = ($route: angular.route.IRouteService, staffTestImportService: StaffTestImportService) =>
            staffTestImportService.getStaffTestImportStatus($route.current.params.districtId);

        /* @ngInject */
        const hasInitialImportStarted = ($route: angular.route.IRouteService, importStatusService: ImportStatusService) => 
            importStatusService.getAll($route.current.params.districtId).then(res => res.startedOn != null);

        /* @ngInject */
        const importStatus = ($route: angular.route.IRouteService, importStatusService: ImportStatusService) =>
            importStatusService.getAll($route.current.params.districtId);

        /* @ngInject */
        const isNewExperience = ($route: angular.route.IRouteService, featureToggleService: FeatureToggleService) =>
            featureToggleService.isNewExperience($route.current.params.districtId);

        $routeProvider
            .when("/:districtId", {
                template: `
                    <clever-match-landing-v2 ng-if="isNewExperience"></clever-match-landing-v2>
                    <clever-match-landing ng-if="!isNewExperience"></clever-match-landing>
                `,
                /* @ngInject */
                controller: function ($scope: angular.IScope, $route: angular.route.IRouteService) {
                    const IS_NEW_EXPERIENCE = "isNewExperience";
                    $scope.isNewExperience = $route.current.locals[IS_NEW_EXPERIENCE];
                },
                resolve: {
                    navianceSchools,
                    cleverSchools,
                    matches,
                    initData,
                    pilotStatus,
                    staffImportStatus,
                    importStatus,
                    testImportProgress,
                    staffTestImportStatus,
                    isNewExperience
                }
            })
            .when("/:districtId/preview", {
                template: "<match-preview></match-preview>",
                resolve: {
                    navianceSchools,
                    cleverSchools,
                    matches,
                    isNewExperience
                }
            })
            .when("/:districtId/history", {
                template: "<match-history></match-history>",
                resolve: {
                    /* @ngInject */
                    history: function($route: angular.route.IRouteService, districtService: DistrictService) {
                        return districtService.getHistory($route.current.params.districtId);
                    }
                }
            })
            .when("/:districtId/student-test-import", {
                template: "<student-test-import></student-test-import>",
                resolve: {
                    testImportProgress,
                    matches,
                    hasInitialImportStarted,
                    importStatus,
                    isNewExperience
                }
            })
            .when("/:districtId/student-import-records", {
                template: "<student-import-records></student-import-records>",
                resolve: {
                    importStatus,
                    testImportProgress,
                    staffImportStatus,
                    matches,
                    staffTestImportStatus,
                    isNewExperience
                }
            })
            .when("/:districtId/staff-test-import", {
                template: "<staff-test-import></staff-test-import>",
                resolve: {
                    staffTestImportStatus,
                    staffImportStatus,
                    isNewExperience
                }
            })
            .when("/:districtId/staff-import-records", {
                template: "<staff-import-records></staff-import-records>",
                resolve: {
                    staffImportStatus,
                    staffTestImportStatus,
                    importStatus,
                    testImportProgress,
                    isNewExperience
                }
            })
            .when("/:districtId/import-student-data", {
                template: "<import-student-data></import-student-data>",
                resolve: {
                    staffImportStatus,
                    testImportProgress,
                    matches,
                    hasInitialImportStarted,
                    importStatus,
                    staffTestImportStatus,
                    isNewExperience
                }
            })
            .when("/:districtId/import-staff-data", {
                template: "<import-staff-data></import-staff-data>",
                resolve: {
                    staffTestImportStatus,
                    staffImportStatus,
                    importStatus,
                    testImportProgress,
                    isNewExperience,
                    hasSavedRoles: ($route:{current:{params:{ districtId: string }}}, configurationService: ConfigurationService) => {
                        return configurationService.getTitleToRoleConfiguration($route.current.params.districtId)
                            .then(config => !!config.created);
                    }
                }
            })
            .when("/:districtId/staff-roles", {
                template: "<staff-roles></staff-roles>",
                resolve: {
                    staffImportStatus,
                    staffTestImportStatus,
                    importStatus,
                    testImportProgress
                }
            })
            .otherwise({ redirectTo: "/" });
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/app-routes/app.routes.ts